import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TimeService } from '@bayclubs/utils';
import * as moment from 'moment';

import { DatePickerModel } from '../date-picker.component';

@Component({
    selector: 'app-day-picker',
    templateUrl: './day-picker.component.html',
    styleUrls: ['./day-picker.component.scss', '../picker-form.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DayPickerComponent {
    readonly isOpen = input(false);
    readonly min = input<moment.Moment | undefined>(undefined);
    readonly max = input<moment.Moment | undefined>(undefined);
    readonly model = input.required<DatePickerModel>();

    readonly weeks = computed<moment.Moment[][]>(() => {
        const date = this.model().date();
        if (!date) return [];
        const weeks: moment.Moment[][] = [];
        let daysInWeek: moment.Moment[] = [];
        let start = this.timeService.startOfMonth(date);
        const end = this.timeService.endOfMonth(date);

        while (start <= end) {
            daysInWeek.push(start);
            start = this.timeService.addDays(start, 1);

            if (start.date() / 6 === 0) {
                weeks.push(daysInWeek);
                daysInWeek = [];
            }
        }
        weeks.push(daysInWeek);
        return weeks;
    });

    constructor(private timeService: TimeService) {}

    public selectDay(date: moment.Moment): void {
        if (this.isDisabled(date)) return;
        const m = this.model();
        const cloned = date.clone();
        m.date.set(cloned);
        m.day.set(cloned.date());
    }

    public isSelected(date: moment.Moment): boolean {
        return this.model().day() === date.date();
    }

    public isDisabled(date: moment.Moment): boolean {
        const m = this.model();
        const min = this.min();
        const max = this.max();
        return m.month() != null && m.year() != null
            && ((min && date.isBefore(min)) || (max && date.isAfter(max)));
    }

    trackByWeek = (_: number, week: moment.Moment[]) => week.length ? week[0].valueOf() : _;
    trackByDay = (_: number, day: moment.Moment) => day.valueOf();
}
